import styled from "style/styled-components";

const DarkSecondaryText = styled.span`
  color: ${({ theme }) => theme.color.font.onLightBackground};
`;

export default DarkSecondaryText;
